import React, {useState, useEffect} from 'react';
import _ from 'lodash';
import IndexTableFiltersPanelLabel from './IndexTableFiltersPanelLabel';
import {propTypes} from 'mobx-react';

export default function IndexTableFiltersPanelChips({chips, handleClearButtonClick}) {
    const [showAll, setShowAll] = useState(false);

    const getFilters = () => {
        if (showAll) {
            return chips;
        }

        if (chips.length > 5) {
            var toShow = _.take(chips, 5);
            toShow.push(
                <IndexTableFiltersPanelLabel
                    label={__('Show all')}
                    color="show-all"
                    onClick={() => {
                        setShowAll(true)
                    }}
                />
            )

            return toShow;
        }

        return _.take(chips, 5);
    }

    useEffect(() => {
        if (chips.length <= 5) {
            setShowAll(false);
        }
    })
    return (
        <div className="filters-panel-row filters-panel-active-filters">
            <div className="filters-panel-active-filters-left">
                <div className="filters-panel-caption">
                    {__('Filters')}
                </div>
                <div className="filters-panel-chips">
                    {getFilters()}
                </div>
            </div>
            <div className="filters-panel-active-filters-right">
                {chips.length > 0 && <div className="filters-panel-clear-button" onClick={handleClearButtonClick}>
                    {__('Clear filters')}
                </div>}
            </div>
        </div>
    )
}